import { Label, Switch, cn } from '@design-system';
import { FlaskConical } from 'lucide-react';

interface SampleClientsToggleProps {
  showSampleClients: boolean;
  onToggle: (show: boolean) => void;
  isMobile?: boolean;
  className?: string;
}

export function SampleClientsToggle({
  showSampleClients,
  onToggle,
  isMobile,
  className,
}: SampleClientsToggleProps) {
  return (
    <Label
      role="button"
      htmlFor="sample-clients-toggle"
      className={cn(
        'bg-transparent flex pl-2 pr-2.5 items-center gap-2 rounded-md h-10 border transition-colors',
        {
          'bg-primary/5 border-primary/10': showSampleClients,
          "h-9 pr-2.25 pl-2.25": isMobile
        },
        className,
      )}
      onClick={() => {
        if (isMobile) {
          onToggle(!showSampleClients)
        }
      }}
    >
      <FlaskConical
        className={cn('text-muted-foreground size-4 transition-colors', {
           'text-primary': showSampleClients,
        })}
      />
      {!isMobile && <><span
        className={cn('text-foreground cursor-pointer text-sm font-medium transition-colors', {
          'text-primary': showSampleClients,
        })}
      >
        Sample Clients
      </span>
      <Switch
        id="sample-clients-toggle"
        checked={showSampleClients}
        onCheckedChange={onToggle}
      /></>}
    </Label>
  );
}
